import { stringifyUrl } from "query-string";
import { IApiResourceResponse } from "../../@typings/client";
import { AdminProfileInfo } from "../typings/Profiles";
import { UsersLoader } from "./UsersLoader";
import { ProfilesQuery } from "./ProfilesApi";

export class ProfilesAdminsApi {
  public static updateAdminProfile(
    id: string,
    data: IApiResourceResponse<AdminProfileInfo>,
    query: ProfilesQuery = {}
  ) {
    const url = stringifyUrl({ url: `/users_profiles_admins/${id}`, query }, { arrayFormat: "comma" });
    return UsersLoader.patch({ url, data });
  }
}
